import { getPayments, deletePayment as deletePaymentApi } from '../services/api';
import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';
import { notifyDataChanged } from '../utils/dataEvents';
import type { CreatorInfo } from '../utils/permissions';
import { entityStoreMessages } from './storeHelpers';

export interface Payment extends CreatorInfo {
  id: string;
  userId: string; // 建立者（權限判斷用）
  customerId?: string;
  projectId?: string | null;
  customer: {
    id: string;
    name: string;
    archived?: boolean;
  };
  project?: {
    id: string;
    name: string;
  } | null;
  amount: number;
  paymentMethod: string;
  paymentDate: string;
  notes?: string;
}

const usePaymentStoreBase = createEntityStore<Payment>({
  entityName: 'payment',
  fetchFn: getPayments,
  deleteFn: deletePaymentApi,
  toast,
  messages: entityStoreMessages,
});

export { usePaymentStoreBase };

export const usePaymentStore = () => {
  const store = usePaymentStoreBase();

  const confirmDelete = async () => {
    await store.confirmDelete();
    notifyDataChanged('payments');
  };

  return {
    payments: store.items,
    pagination: store.pagination,
    error: store.error,
    isPageLoading: store.isPageLoading,
    showDeleteConfirmModal: store.showDeleteConfirmModal,
    isDeleting: store.isDeleting,
    fetchPayments: store.fetchItems,
    setCurrentPage: store.setCurrentPage,
    handleDelete: store.handleDelete,
    confirmDelete,
    closeDeleteModal: store.closeDeleteModal,
    updatePayment: store.updateItem,
    addPayment: store.addItem,
  };
};
